import React from "react"
import _ from "lodash"
import { localizeNum } from "data/lib/numbers"
import { Label_s } from 'styles/app-styles'
import { SingleRow_s } from 'components/table/hovers/hover-styles'

type IHover = {
  data: {}
}

const OverridesHover = (props: IHover) => {
  const overrideType = props.data['overridetype']
  const hasOverrides = overrideType && overrideType !== "None"

  return (
    <div>
      <SingleRow_s style={{width: '300px', flexWrap: 'wrap'}}>
        <div style={{width: '130px', marginBottom: '15px'}}>
          <Label_s>Override Type</Label_s>
          { overrideType || 'N/A' }
        </div>
        { hasOverrides && props.data['overriderent'] && <div style={{width: '130px', marginBottom: '15px'}}>
          <Label_s>Rent</Label_s>
          { localizeNum(props.data['overriderent'], 4) }
        </div> }
        { hasOverrides && props.data['overrideti'] && <div style={{width: '130px', marginBottom: '15px'}}>
          <Label_s>T.I.</Label_s>
          { localizeNum(props.data['overrideti'], 4) }
        </div> }
        { hasOverrides && props.data['overridelc'] && <div style={{width: '130px', marginBottom: '15px'}}>
          <Label_s>L.C.</Label_s>
          { localizeNum(props.data['overridelc'], 4) }
        </div> }
        { hasOverrides && props.data['overrideoc'] && <div style={{width: '130px', marginBottom: '15px'}}>
          <Label_s>O.C.</Label_s>
          { localizeNum(props.data['overrideoc'], 4) }
        </div> }
        { hasOverrides && props.data['overriderenewalprob'] && <div style={{width: '130px', marginBottom: '15px'}}>
          <Label_s>Renewal Probability</Label_s>
          { localizeNum(props.data['overriderenewalprob'], 4) }
        </div> }
        { hasOverrides && props.data['overridedowntime'] && <div style={{width: '130px', marginBottom: '15px'}}>
          <Label_s>Downtime</Label_s>
          { localizeNum(props.data['overridedowntime'], 0) }
        </div> }
      </SingleRow_s>
    </div>
  )
}

export default OverridesHover
